module.exports = __webpack_public_path__ + "static/media/charles07.a505f0e6.jpg";